<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="用户列表"
        left-arrow
        :fixed="flexfalg"
        @click-left="onClickLeft"
      />
      <div class="top"></div>
      <!-- <Nav :title="'缴费记录'" :fixed="true"></Nav>
      <div class="top"> -->
    </div>
    <div v-if="emptyflag">
      <van-empty
        image="https://account.kmmds.top/datainfo_pic/error.png"
        description="暂无缴费信息"
      />
    </div>
    <div class="paycard" v-for="(item, index) in CompanyList" :key="index" @click="gonext(item)">
      <div claass="content">
        <div class="Crow">
          <div>单位名：</div>
          <div class="green">{{ item.name }}</div>
        </div>
        <div class="Crow">
          <div>单位地址</div>
          <div>{{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import backindex from "@/mixins/backindex";
export default {
  mixins: [backindex],
  data() {
    return {
      emptyflag: false,
      flexfalg: true,
      clientId: "",
      name: "",
      payHisInfo: [
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
        { name: "aaaa", adrees: "www" },
      ],
      CompanyList:[],
    };
  },
  components: {
    Nav,
  },
  mounted() {
      this.queryallquestionnairesurveyinfo()
  },
  methods: {
       async queryallquestionnairesurveyinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/queryallquestionnairesurveyinfo";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.CompanyList = data.data.data.data;
            if (this.CompanyList.length == 0) {
              this.showemty = true;
            } else {
              this.showemty = false;
            }
          }
        );
      } catch (error) {}
      },
    onClickLeft() {
      this.$router.push("/index");
    },
    Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.$router.push("/confUser");
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    //获取列表
    gonext(item){
       this.$router.push({
              path: "/userlist",
              query: {
              surveyId: item.id,
              },
            });
          
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100vw;
  background-color: #f7f8fa;
  .top {
    height: 50px;
  }
  .paycard {
    padding: 5px;
    width: 90%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 15px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: 0 4px 8px #6666;
    background-color: white;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #5b8df6;
    font-size: 16px;
  }
  .content {
    width: 90%;

    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 40px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
}
</style>